import React, { useRef, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import classNames from 'classnames';
import Header from '@/partials/Header';
import Sidebar from '@/partials/Sidebar';
import { OutletContext } from '@/types';

const StaticLayoutInner = ({ children, noPadding, hideSidebar, centerContent }: { children: React.ReactNode, noPadding?: boolean, hideSidebar?: boolean, centerContent?: boolean }) => {
	const [sidebarOpen, setSidebarOpen] = useState(false);
	const { auth, project } = useOutletContext<OutletContext>();

	const sidebarTrigger = useRef(null);
	const sidebar = useRef(null);

	return (
		<div className="flex flex-col h-screen overflow-hidden" style={{ paddingTop: 'var(--notification-height, 0px)' }}>
			{/* Site header */}
			<Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} user={auth?.user} project={project} sidebarTrigger={sidebarTrigger}  />
			<div className="flex h-[calc(var(--vh,1vh)*100-47px-var(--notification-height,0px))] lg:h-[calc(var(--vh,1vh)*100-65px-var(--notification-height,0px))]">
				{/* Sidebar */}
				{project && !hideSidebar && (
					<Sidebar
						sidebarOpen={sidebarOpen}
						setSidebarOpen={setSidebarOpen}
						project={project}
						user={auth?.user}
						trigger={sidebarTrigger}
						sidebar={sidebar}
					/>
				)}
				{/* Content area */}
				<div className="relative flex flex-col flex-1 overflow-y-auto bg-[#F7F6F2]">
					<main className="min-h-full">
						<div className={classNames(
							!noPadding && 'py-8 sm:py-10 px-4 sm:px-[72px]',
							'min-h-full',
							!project && 'max-w-7xl mx-auto',
							centerContent && 'flex',
						)}>
							{children}
						</div>
					</main>
				</div>
			</div>
		</div>
)
}

export default StaticLayoutInner;
